import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import PaypalDisputes from "./sections/PaypalDisputes";
import PaypalPayments from "./sections/PaypalPayments";
import TopProducts from "./sections/TopProducts";
import TopStores from "./sections/TopStores";
import Shopify from "./sections/Shopify";

const Dashboard = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(true);
  const [checked3, setChecked3] = useState(true);
  const [checked4, setChecked4] = useState(true);
  const [checked5, setChecked5] = useState(true);
  const [width, setWidth] = useState(6);

  // Set width of sections when checkbox changed
  useEffect(() => {
    let checked_counts = 0;
    if (checked1) {
      checked_counts += 1;
    }
    if (checked2) {
      checked_counts += 1;
    }
    if (checked3) {
      checked_counts += 1;
    }
    if (checked4) {
      checked_counts += 1;
    }
    if (checked_counts === 3) {
      setWidth(4);
    } else if (checked_counts === 1) {
      setWidth(12);
    } else {
      setWidth(6);
    }
  }, [checked1, checked2, checked3, checked4]);

  const onCheckBox = (e) => {
    if (e.target.id === "disputes") {
      setChecked1(e.target.checked);
    } else if (e.target.id === "payments") {
      setChecked2(e.target.checked);
    } else if (e.target.id === "top_products") {
      setChecked3(e.target.checked);
    } else if (e.target.id === "shopify") {
      setChecked4(e.target.checked);
    } else if (e.target.id === "top_campaigns") {
      setChecked5(e.target.checked);
    }
  };

  const [topStores, setTopStores] = useState("");

  return (
    <div className={classes.root}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h4"> Dashboard </Typography>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <Divider variant="fullWidth" />
        </Grid>{" "}
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <Grid
              item
              style={{
                width: "19%",
              }}
            >
              <Paper
                style={{
                  height: 40,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    style={{
                      height: "100%",
                      fontSize: 20,
                      width: "100%",
                    }}
                    onChange={onCheckBox}
                    control={
                      <Checkbox
                        id="disputes"
                        checked={checked1}
                        color="primary"
                        style={{
                          width: "50%",
                          pointerEvents: "none",
                        }}
                      />
                    }
                    label="Disputes"
                  />
                </Grid>{" "}
              </Paper>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "19%",
              }}
            >
              <Paper
                style={{
                  height: 40,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    style={{
                      height: "100%",
                      fontSize: 20,
                      width: "100%",
                    }}
                    onChange={onCheckBox}
                    control={
                      <Checkbox
                        id="payments"
                        checked={checked2}
                        color="primary"
                        style={{
                          width: "50%",
                          pointerEvents: "none",
                        }}
                      />
                    }
                    label="Payments"
                  />
                </Grid>{" "}
              </Paper>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "19%",
              }}
            >
              <Paper
                style={{
                  height: 40,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    style={{
                      height: "100%",
                      fontSize: 20,
                      width: "100%",
                    }}
                    onChange={onCheckBox}
                    control={
                      <Checkbox
                        id="top_products"
                        checked={checked3}
                        color="primary"
                        style={{
                          width: "50%",
                          pointerEvents: "none",
                        }}
                      />
                    }
                    label="Products"
                  />
                </Grid>{" "}
              </Paper>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "19%",
              }}
            >
              <Paper
                style={{
                  height: 40,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    style={{
                      height: "100%",
                      fontSize: 20,
                      width: "100%",
                    }}
                    onChange={onCheckBox}
                    control={
                      <Checkbox
                        id="shopify"
                        checked={checked4}
                        color="primary"
                        style={{
                          width: "50%",
                          pointerEvents: "none",
                        }}
                      />
                    }
                    label="Shopify"
                  />
                </Grid>{" "}
              </Paper>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "19%",
              }}
            >
              <Paper
                style={{
                  height: 40,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    style={{
                      height: "100%",
                      fontSize: 20,
                      width: "100%",
                    }}
                    onChange={onCheckBox}
                    control={
                      <Checkbox
                        id="top_campaigns"
                        checked={checked5}
                        color="primary"
                        style={{
                          width: "50%",
                          pointerEvents: "none",
                        }}
                      />
                    }
                    label="Campaigns"
                  />
                </Grid>{" "}
              </Paper>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <Divider variant="fullWidth" />
        </Grid>{" "}
        <Grid item xs={12}>
          <Grid container direction="row" spacing={2}>
            {" "}
            {checked1 ? (
              <Grid item xs={width}>
                <PaypalDisputes />
              </Grid>
            ) : null}{" "}
            {checked2 ? (
              <Grid item xs={width}>
                <PaypalPayments />
              </Grid>
            ) : null}{" "}
            {checked3 ? (
              <Grid item xs={width}>
                <TopProducts />
              </Grid>
            ) : null}{" "}
            {checked4 ? (
              <Grid item xs={width}>
                <Shopify />
              </Grid>
            ) : null}{" "}
            {checked5 ? (
              <Grid item xs={12}>
                {" "}
                {/* Socket */} {/* <TopStores topStores={topStores} /> */}{" "}
                <TopStores />
              </Grid>
            ) : null}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default Dashboard;
